import React, { Fragment } from 'react'
import './style.scss'

const CreditLogin = ({
  error,
  email,
  password,
  handleWithAuth,
  handleAuthWithView,
  handleFacebookAuth,
  fbSdkLoaded,
  visibleConsumeButton,
}) => (
  <Fragment>
    <Fragment>
      {Boolean(error) && <p style={{ color: 'red', textAlign: 'center', margin: 16 }}>{error}</p>}
    </Fragment>

    <div className='label-float'>
      <input type='email' placeholder=' ' onChange={email} />
      <label>Email</label>
    </div>
    <div className='label-float'>
      <input type='password' placeholder=' ' onChange={password} />
      <label>Senha</label>
    </div>
    <div className='auth_group'>
      <button onClick={handleAuthWithView} className='auth_register'>
        Cadastrar
      </button>
      <button onClick={handleWithAuth} className='auth_login' disable={visibleConsumeButton}>
        Entrar
      </button>
    </div>
  </Fragment>
)

// TODO: use ts
// CreditLogin.propTypes = {
//   fbSdkLoaded: PropTypes.bool,
//   email: PropTypes.func,
//   password: PropTypes.func,
//   handleWithAuth: PropTypes.func,
//   handleAuthWithView: PropTypes.func,
//   handleFacebookAuth: PropTypes.func,
//   visibleConsumeButton: PropTypes.string,
// }

export default CreditLogin
